import * as loadjs from 'loadjs';

interface WordCountConfig {
    maxCharCount: string;
    showParagraphs: boolean;
    showWordCount: boolean;
    showCharCount: boolean;
    countSpacesAsChars: boolean;
    countHTML: boolean;
}
interface Config {
    customConfig: string;
    wordcount?: WordCountConfig;
}
interface CKEDITOR {
    replace(elem: string | HTMLTextAreaElement, config: Config): any;
};

declare let CKEDITOR: CKEDITOR;

export default function (target: HTMLElement) {
    loadjs(['//app.genetics-gsa.org/includes/abstracts/ckeditor-4.7.0/ckeditor.js'], {
        success: function () {
            let elem = target as HTMLTextAreaElement;
            let baseConfig = elem.dataset["gsRichEditorConfig"];
            if (!baseConfig) {
                throw "The data-gs-rich-editor-config is required for gs-rich-editor";
            }

            let config: Config = {
                customConfig: baseConfig
            };
            let maxCharCount = elem.dataset["gsRichEditorMaxCharCount"];
            if (maxCharCount) {
                config.wordcount = {
                    maxCharCount: maxCharCount,
                    showParagraphs: false,
                    showWordCount: false,
                    showCharCount: true,
                    countSpacesAsChars: false,
                    countHTML: false,
                };
            }
            CKEDITOR.replace(elem, config);
        }
    });
}


